module.exports = __webpack_public_path__ + "static/Number 106-43113c0ef3fb7ca42617778bb1e7d7f7.jpg";